import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

import { MgButtonModule } from '@app/src/app/button';
import { WelcomeOwnerModule } from '@app/src/app/ftue/Welcome/components/WelcomeOwner';
import { WelcomeStudentModule } from '@app/src/app/ftue/Welcome/components/WelcomeStudent';
import { WelcomeTeacherManagerModule } from '@app/src/app/ftue/Welcome/components/WelcomeTeacherManager';

import { WelcomeDialog } from './WelcomeDialog.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgButtonModule,
    WelcomeOwnerModule,
    WelcomeStudentModule,
    WelcomeTeacherManagerModule,

    // External dependencies
    CommonModule,
    MatDialogModule,
  ],
  declarations: [WelcomeDialog],
  exports: [WelcomeDialog],
})
export class WelcomeDialogModule {}
